module.exports = __webpack_public_path__ + "img/PD_7.b5d71e8b.png";